import { Component } from '@angular/core';

@Component({
    selector: 'app-private-browsing-notice',
    templateUrl: './private-browsing-notice.component.html',
    styleUrls: ['./private-browsing-notice.component.css'],
    standalone: false
})
export class PrivateBrowsingNoticeComponent {

  constructor() { }

}
